export default "__VITE_ASSET__DWej4qyp__"